$(document).ready(function(){var e=$(".price-ui-badge__sticker-text");e&&e.text()=="Sold Out"&&e.parents(".price-ui-badges").hide()});
//# sourceMappingURL=/s/files/1/0135/0251/3252/t/59/assets/lcs-product.js.map?v=1642629485
